/**
 * English Contact Translations
 * 联系页翻译模块 - 英语
 * 
 * 包含联系表单、联系信息、地图等翻译
 */

import type { ContactTranslations } from '../../types';

export const enContact: ContactTranslations = {
  title: 'Contact Us',
  subtitle: 'We\'d love to hear from you.',
  header: {
    title: 'Contact Us',
    subtitle: 'We\'d love to hear from you.',
  },
  form: {
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    interested: 'Product Interest',
    selectProduct: 'Please select',
    message: 'Message',
    send: 'Send Message',
    sending: 'Sending...',
  },
  info: {
    headquarters: 'Headquarters',
    address: 'Building 25, Wanyang Science & Technology Park, 26 Tingwang Road, Tingjiang Town, Mawei District, Fuzhou, Fujian, China',
    phoneSupport: 'Phone Support',
    phone: '+86-15080458735',
    phoneHours: 'Mon-Fri 9am - 6pm (GMT+8)',
    emailUs: 'Email Us',
    sales: 's3@jinghui-tech.com',
    support: 's3@jinghui-tech.com',
    distributor: 'Distributor Network',
    distributorDesc: 'We\'re looking for global distributors. Join us to bring green heating to your country.',
  },
  success: {
    title: 'Message Sent!',
    desc: 'Thank you for contacting us. Our sales team will respond within 24 hours.',
    sendAnother: 'Send another message',
  },
};
